document.addEventListener('DOMContentLoaded', function () {
    const targets = document.getElementsByClassName('collection-tab');
    for (let i = 0; i < targets.length; i++) {
        targets[i].addEventListener('click', changeTab, false);
    }
    // タブメニューボタンをクリックすると実行
    function changeTab() {
        // タブのclassを変更
        document.getElementsByClassName('collection-tab-active')[0].classList.remove('collection-tab-active');
        this.classList.add('collection-tab-active');
        // コンテンツのclassの値を変更
        document.getElementsByClassName('collection-content-display')[0].classList.remove('collection-content-display');
        const arrayTabs = Array.prototype.slice.call(targets);
        const index = arrayTabs.indexOf(this);
        document.getElementsByClassName('collection-content')[index].classList.add('collection-content-display');
    };
}, false);